export default __webpack_public_path__ + "static/media/white_logo_large.969a6d5e.svg";